import { Injectable, inject } from '@angular/core';
import { CookieService, CookieSettings } from './cookie.service';
import { DateTime } from 'luxon';
import { environment } from '../../../environments/environment';
import { buildIdentityServerUrls } from 'portal-shared';

@Injectable({
  providedIn: 'root',
})
export class ActivityTrackingService {
  //Used to detect idle and auto-logout

  private identityServerUrls = buildIdentityServerUrls(
    environment.identityServer.url,
  );

  private cookieService = inject(CookieService);

  private excludedUrls: string[] = [
    this.identityServerUrls.connectToken,
    this.identityServerUrls.jwks,
    this.identityServerUrls.userInfo,
    this.identityServerUrls.sessionCheck,
  ];

  trackActivity(url: string): void {
    if (this.shouldTrackActivity(url)) {
      const expires = DateTime.now().plus(
        environment.autoLogoutMinutes * 60 * 1000,
      );
      this.cookieService.setCookie({
        name: 'PortalAuthExpirationTicket',
        expires: expires,
        value: expires.toMillis().toString(),
        secure: true,
        session: true,
      } as CookieSettings);
    }
  }

  private shouldTrackActivity(url: string): boolean {
    return !this.excludedUrls.some((excludedUrl) => url.includes(excludedUrl));
  }
}
